(function () {
  if (typeof window === 'undefined') return;

  function attach(input, container) {
    if (input.dataset.keynav === 'bound') return;
    input.dataset.keynav = 'bound';
    var idx = -1;

    function getItems() {
      return Array.from(container.querySelectorAll(
        '.predictive__suggestions a, ' +
        '.predictive__results a, ' +
        '.predictive__products a, ' +
        '.predictive__collections a, ' +
        '.predictive__pages a, ' +
        '.predictive__articles a, ' +
        '.search-empty__pill, ' +
        '.search-empty__quick, ' +
        '.search-empty__brand-card'
      )).filter(function (a) { return a.offsetWidth > 0; });
    }

    function highlight(items) {
      items.forEach(function (a, i) {
        a.classList.toggle('is-keynav-focus', i === idx);
        if (i === idx) {
          a.scrollIntoView({ block: 'nearest' });
        }
      });
    }

    input.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter' && e.key !== 'Escape') return;
      var items = getItems();
      if (!items.length) {
        if (e.key === 'Escape') input.blur();
        return;
      }

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        idx = (idx + 1) % items.length;
        highlight(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        idx = idx <= 0 ? items.length - 1 : idx - 1;
        highlight(items);
      } else if (e.key === 'Enter') {
        if (idx >= 0 && items[idx]) {
          e.preventDefault();
          items[idx].click();
        }
      } else if (e.key === 'Escape') {
        idx = -1;
        highlight(items);
        input.blur();
      }
    });

    input.addEventListener('input', function () {
      idx = -1;
      var items = getItems();
      items.forEach(function (a) { a.classList.remove('is-keynav-focus'); });
    });
  }

  function bind() {
    document.querySelectorAll('input[type="search"][name="q"], .search__input').forEach(function (input) {
      var container = input.closest('predictive-search, .search-bar, .search-empty, form[action$="/search"]') || document.body;
      attach(input, container);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
